import PopoverButton from '../PopoverButton.jsx';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline/index.js';
import { ShortDaysOfWeek } from '../../lib/DateTime.js';
import { useState } from 'react';

const CopyHoursButton = ({ onCopy, skipDay }) => {
    const [toDays, setToDays] = useState([]);

    function toggle(idx) {
        if (toDays.indexOf(idx) > -1) {
            const newToDays = [...toDays];
            newToDays.splice(toDays.indexOf(idx), 1);
            setToDays(newToDays);
        } else {
            setToDays([...toDays, idx]);
        }
    }

    function doCopy() {
        const applyDays = [...toDays];
        if (applyDays.indexOf(skipDay) < 0) {
            applyDays.push(skipDay);
        }
        onCopy(applyDays);
    }

    return (
        <PopoverButton
            btnContent={
                <DocumentDuplicateIcon className="w-5 h-5 text-black ml-2" />
            }
        >
            {({ close }) => (
                <div>
                    <div>Copy these hours to:</div>
                    {ShortDaysOfWeek.map((dow, idx) => (
                        <label className="flex items-center py-1" key={idx}>
                            <input
                                type="checkbox"
                                className="mr-2"
                                value={idx}
                                disabled={skipDay === idx}
                                checked={
                                    skipDay === idx || toDays.indexOf(idx) > -1
                                }
                                onChange={() => toggle(idx)}
                            />
                            {dow}
                            {skipDay === idx && (
                                <span className="ml-2 text-gray-500">
                                    (selected day)
                                </span>
                            )}
                        </label>
                    ))}
                    <button
                        type="button"
                        className="btn-pill mt-2"
                        onClick={() => {
                            doCopy();
                            setToDays([]);
                            close();
                        }}
                    >
                        Apply
                    </button>
                </div>
            )}
        </PopoverButton>
    );
};

export default CopyHoursButton;
